import React from "react";
import { Empty } from "antd";
import { getNoDataMessage } from "../../../TagMonitorDash/EmptyChart";
import "./styles.scss";

/**
 * ChartNoData Component - Shows a "no data" message on top of a chart,
 * in the same format as the Tag Monitor page
 *
 * @param {boolean} show - Show the no data message
 * @param {string} dataName - Name used in the default message ("No {dataName} data available.")
 * @param {string} message - Custom message, overrides the default message
 * @param {React.ReactNode} children - The chart (optional, without children only the message is shown)
 */
const ChartNoData = ({ show, dataName, message, children }) => {
  return (
    <div className="chart-no-data">
      {children}
      {show && (
        <div className="chart-no-data-message">
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={false} />
          <div>{message || getNoDataMessage(dataName)}</div>
        </div>
      )}
    </div>
  );
};

export default ChartNoData;
